import styled, { css } from 'styled-components';
import { Flex } from 'common/common-components.styled';

export const StyledIconContainer = styled(Flex)`
  min-width: 25px;
  height: 32px;
`;

interface IsOpenProps {
  open: boolean;
}

export const StyledMenuItemContainer = styled.div<IsOpenProps>`
  &:last-child {
    border-bottom: none;
  }

  ${({ open }) =>
    open &&
    css`
      background-color: ${({ theme }) => theme.colors.grey50};
    `};
`;

const subtitleHoverMixin = css`
  background-color: ${({ theme }) => theme.colors.grey100};
  border-left: 5px solid ${({ theme }) => theme.colors.emeraldGreen};
  padding-left: 15px;

  .icon {
    display: none;
  }
  .icon-hovered {
    display: block;
  }
`;

interface StyledSubtitle extends IsOpenProps {
  dashboardTourIsStarted: boolean;
  isMinimized: boolean;
  indicator?: boolean;
}

export const StyledSubtitle = styled.div<StyledSubtitle>`
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.grey600};
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  pointer-events: ${({ dashboardTourIsStarted }) => (dashboardTourIsStarted ? 'none' : 'auto')};
  position: relative;

  ${({ indicator, isMinimized }) =>
    indicator &&
    !isMinimized &&
    css`
      &:after {
        content: '';
        height: 6px;
        width: 6px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.pink};
        margin-left: 5px;
      }
    `};

  &:hover {
    ${subtitleHoverMixin}
  }

  ${({ open }) => open && subtitleHoverMixin};
`;

export const StyledInfoChip = styled.div`
  margin-left: 15px;
  text-transform: lowercase;
  font-weight: 100;
`;
